import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { Global } from '../../../global/global';
import { BetslipPage } from '../betslip/betslip';
import { LoginModalPage } from '../../shared/login-modal/login-modal';
import { RegisterModalPage } from '../../shared/register-modal/register-modal';
import { LottoBetpanelService } from 'baseline-lib';



/**
 * Generated class for the LotteryMenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-lottery-menu',
  templateUrl: 'lottery-menu-page.html',
})
export class LotteryMenuPage {
  showprofile : any;

  constructor(public navCtrl: NavController, public navParams: NavParams, 
    public globalData:Global,public modalCtrl : ModalController, public _lottoBetpanelService: LottoBetpanelService,) {
   
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LotteryMenuPage');
  }

  openBetSlipPage()
 {   
   this.navCtrl.push(BetslipPage)
 }

 loginClicked()
  {
    let profileModal = this.modalCtrl.create(LoginModalPage);
    profileModal.present();    
  }

  registerClicked()
  {
    let registerModal = this.modalCtrl.create(RegisterModalPage);
    registerModal.present();
  }

  profileClicked(){
    if(this.showprofile){
      this.showprofile = false;
    }else{
      this.showprofile = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/lottery/lottery-menu-page/lottery-menu-page.ts